import { styled } from '@mui/material/styles';
import { AccountBoxOutlined } from '@mui/icons-material';

export const ImagePlaceHolder = styled(AccountBoxOutlined)`
  width: 200px;
  height: 200px;
`;